import { PUBLICURL } from "../../../main_config";

export default theme => ({
	title: {
		fontSize: theme.typography.h2Desktop.fontSize,
		fontWeight: theme.typography.fontWeightBold,
		marginTop: theme.breakpoints.up("lg") ? 0 : 120,
		textAlign: 'center',
		letterSpacing: "1.5px",
		lineHeight: 1.37,
		[theme.breakpoints.down("xs")]: {
			fontSize: '25px !important',
			letterSpacing: "1.25px",
			lineHeight: 1.30,
			marginBottom: '50px'
		},
	},
	containerImg: {
		marginTop: "10px"
	},
	container: {
		marginTop: "10px"
	},
	containerText: {
		[theme.breakpoints.down("xs")]: {
			marginTop: "50px",
			backgroundImage: `url(${PUBLICURL}/assets/images/hire/fondoGris.png)`,
			backgroundRepeat: "no-repeat"
		},
		[theme.breakpoints.up("xs")]: {
			marginTop: "50px"
		},

	}
});
